import React, { useState } from 'react';
import { Document, Page, pdfjs } from 'react-pdf';
// import 'react-pdf/dist/esm/Page/AnnotationLayer.css';
// import 'react-pdf/dist/esm/Page/TextLayer.css';

// Set up the worker for PDF.js from public folder
pdfjs.GlobalWorkerOptions.workerSrc = '/pdf.worker.min.mjs';

interface PDFThumbnailProps {
  url: string;
  onClick: () => void;
  width?: number;
  height?: number;
}

const PDFThumbnail: React.FC<PDFThumbnailProps> = ({ url, onClick, width = 68, height = 68 }) => {
  const [numPages, setNumPages] = useState<number | null>(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(false);

  const onDocumentLoadSuccess = ({ numPages }: { numPages: number }) => {
    setNumPages(numPages);
    setLoading(false);
  };

  const onDocumentLoadError = (error: Error) => {
    console.error('Error loading PDF:', error);
    setError(true);
    setLoading(false);
  };

  if (error) {
    // Fallback to icon if PDF fails to load
    return (
      <div
        onClick={onClick}
        className="rounded-[8px] border border-secondary bg-gray-50 flex flex-col items-center justify-center cursor-pointer hover:bg-gray-100 transition-colors"
        style={{ width, height }}
        title="Click to open PDF"
      >
        <svg
          className="w-6 h-6 text-red-600 mb-1"
          fill="currentColor"
          viewBox="0 0 20 20"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            fillRule="evenodd"
            d="M4 4a2 2 0 012-2h4.586A2 2 0 0112 2.586L15.414 6A2 2 0 0116 7.414V16a2 2 0 01-2 2H6a2 2 0 01-2-2V4zm2 6a1 1 0 011-1h6a1 1 0 110 2H7a1 1 0 01-1-1zm1 3a1 1 0 100 2h6a1 1 0 100-2H7z"
            clipRule="evenodd"
          />
        </svg>
        <span className="text-[9px] font-semibold text-gray-600">PDF</span>
      </div>
    );
  }

  return (
    <div
      onClick={onClick}
      className="relative rounded-[8px] border border-secondary overflow-hidden cursor-pointer hover:opacity-80 transition-opacity bg-white"
      style={{ width, height }}
      title="Click to open PDF"
    >
      {loading && (
        <div className="absolute inset-0 flex items-center justify-center bg-gray-50" style={{ width, height }}>
          <div className="animate-spin rounded-full h-6 w-6 border-b-2 border-primary"></div>
        </div>
      )}

      <Document
        file={url}
        onLoadSuccess={onDocumentLoadSuccess}
        onLoadError={onDocumentLoadError}
        loading=""
        className="flex items-center justify-center"
      >
        <Page
          pageNumber={1}
          width={width}
          height={height}
          renderTextLayer={false}
          renderAnnotationLayer={false}
          className="pdf-page-thumbnail"
        />
      </Document>

      {/* PDF badge overlay */}
      <div className="absolute top-1 right-1 bg-red-600 text-white text-[8px] font-bold px-1.5 py-0.5 rounded">PDF</div>
    </div>
  );
};

export default PDFThumbnail;
